import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { StandardTriageRecommendationPageSelectedEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageRecommendationPageSelectedEventTracking';

export class StandardTriageRecommendationPageCompletedEventTracking extends StandardTriageRecommendationPageSelectedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.STANDARD_TRIAGE_RECOMMENDATION_PAGE_COMPLETED;
}
